var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "uploadFiles" } }, [
      _c("div", { staticClass: "row" }, [
        _vm.$route.name === "conventionInputForm"
          ? _c("div", { staticClass: "col-3 text-center" }, [
              _c(
                "div",
                { staticClass: "text-left" },
                [
                  _c("label", [_vm._v("Formato de ingreso")]),
                  _c("b-form-select", {
                    staticClass: "w-100",
                    attrs: {
                      "data-cy": "input-format",
                      value: _vm.value,
                      options: _vm.inputFormatOptions,
                      disabled: _vm.fromDocDigital
                    },
                    on: {
                      change: function($event) {
                        return _vm.$emit("input", $event)
                      }
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "col-9 mt-5",
            class: {
              "d-none":
                _vm.$route.name === "conventionInputForm" &&
                _vm.value === "paper" &&
                _vm.$route.params.from !== "edit"
            }
          },
          [
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("b-form-select", {
                  staticClass: "w-100 mt-2 mr-4",
                  attrs: { options: _vm.optionsUploadTypes },
                  model: {
                    value: _vm.uploadType,
                    callback: function($$v) {
                      _vm.uploadType = $$v
                    },
                    expression: "uploadType"
                  }
                }),
                _vm.uploadType === "main"
                  ? _c("UploadFile", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Agregar archivo adjunto",
                          expression: "'Agregar archivo adjunto'"
                        }
                      ],
                      staticClass: "mt-2 mr-3",
                      attrs: {
                        "data-cy": "file-upload",
                        maxSizeInMb: _vm.getMaxSize,
                        permission: "*",
                        accept: "application/pdf",
                        text: "Seleccionar",
                        "upload-to": "ed"
                      },
                      model: {
                        value: _vm.mainFile,
                        callback: function($$v) {
                          _vm.mainFile = $$v
                        },
                        expression: "mainFile"
                      }
                    })
                  : _vm._e(),
                _vm.uploadType === "attached"
                  ? _c("UploadFile", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.thereIsMainFile,
                          expression: "thereIsMainFile"
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Agregar archivo adjunto",
                          expression: "'Agregar archivo adjunto'"
                        }
                      ],
                      staticClass: "mt-2",
                      attrs: {
                        permission: "*",
                        text: "Seleccionar",
                        accept: "*",
                        "upload-to": "ed"
                      },
                      on: {
                        input: function($event) {
                          return _vm.addAdditionalFile()
                        }
                      },
                      model: {
                        value: _vm.additionalFile,
                        callback: function($$v) {
                          _vm.additionalFile = $$v
                        },
                        expression: "additionalFile"
                      }
                    })
                  : _vm._e(),
                _vm.uploadType.match(/existingMainFile|existingAttachment/i)
                  ? _c("AttachExistingFile", {
                      staticClass: "mt-2",
                      attrs: {
                        uploadType: _vm.uploadType,
                        thereIsMainFile: _vm.thereIsMainFile
                      }
                    })
                  : _vm._e(),
                _vm.uploadType === "main" && _vm.isResponse
                  ? _c("div", [
                      _vm._v(
                        " Si el archivo que estás adjuntando va para firma, no debe pesar mas de 10 MB "
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _vm.thereIsMainFile
          ? _c(
              "div",
              {
                staticClass: "col-12 mt-5",
                class: {
                  "d-none":
                    _vm.$route.name === "conventionInputForm" &&
                    _vm.value === "paper" &&
                    _vm.$route.params.from !== "edit"
                }
              },
              [
                _c(
                  "b-table-simple",
                  { attrs: { hover: "", small: "" } },
                  [
                    _c(
                      "b-thead",
                      [
                        _c(
                          "b-tr",
                          [
                            _c("b-th", { attrs: { scope: "col" } }, [
                              _vm._v("Nombre archivo")
                            ]),
                            _c("b-th", { attrs: { scope: "col" } }, [
                              _vm._v("Nombre documento")
                            ]),
                            _c(
                              "b-th",
                              {
                                staticClass: "text-center",
                                attrs: { scope: "col" }
                              },
                              [_vm._v("Acción")]
                            ),
                            _vm.withClassification
                              ? _c(
                                  "b-th",
                                  {
                                    staticClass: "text-center",
                                    attrs: { scope: "col" }
                                  },
                                  [_vm._v("Interno")]
                                )
                              : _vm._e(),
                            _vm.withTrueCopy ||
                            _vm.$route.params.from === "edit"
                              ? _c(
                                  "b-th",
                                  {
                                    staticClass: "text-center",
                                    attrs: { scope: "col" }
                                  },
                                  [_vm._v(" Tipo ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "b-tbody",
                      [
                        _c(
                          "b-tr",
                          [
                            _c("b-td", [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Principal",
                                      expression: "'Principal'"
                                    }
                                  ],
                                  staticClass: "d-flex align-items-center"
                                },
                                [
                                  _c("vs-icon", {
                                    staticClass: "mr-1",
                                    attrs: {
                                      icon: "file_present",
                                      size: "medium"
                                    }
                                  }),
                                  _vm._v(" " + _vm._s(_vm.mainFile.name) + " ")
                                ],
                                1
                              )
                            ]),
                            _c(
                              "b-td",
                              [
                                _c("vs-input", {
                                  staticClass: "w-100",
                                  model: {
                                    value: _vm.mainFile.currentDescription,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.mainFile,
                                        "currentDescription",
                                        $$v
                                      )
                                    },
                                    expression: "mainFile.currentDescription"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("b-td"),
                            _vm.withTrueCopy ||
                            _vm.$route.params.from === "edit"
                              ? _c(
                                  "b-td",
                                  { staticClass: "text-center" },
                                  [
                                    _c("b-form-select", {
                                      attrs: { options: _vm.trueCopyOptions },
                                      model: {
                                        value: _vm.mainFile.trueCopy,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.mainFile,
                                            "trueCopy",
                                            $$v
                                          )
                                        },
                                        expression: "mainFile.trueCopy"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._l(_vm.additionalFiles, function(file) {
                          return _c(
                            "b-tr",
                            { key: file.id },
                            [
                              _c("b-td", [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Adjunto",
                                        expression: "'Adjunto'"
                                      }
                                    ],
                                    staticClass: "d-flex align-items-center"
                                  },
                                  [
                                    _c("vs-icon", {
                                      staticClass: "mr-1",
                                      attrs: {
                                        icon: "description",
                                        size: "medium"
                                      }
                                    }),
                                    _vm._v(" " + _vm._s(file.name) + " ")
                                  ],
                                  1
                                )
                              ]),
                              _c(
                                "b-td",
                                [
                                  _c("vs-input", {
                                    staticClass: "w-100",
                                    model: {
                                      value: file.currentDescription,
                                      callback: function($$v) {
                                        _vm.$set(
                                          file,
                                          "currentDescription",
                                          $$v
                                        )
                                      },
                                      expression: "file.currentDescription"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-td",
                                { staticClass: "text-center" },
                                [
                                  _c("vs-icon", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Eliminar",
                                        expression: "'Eliminar'"
                                      }
                                    ],
                                    staticClass: "cursor-pointer",
                                    attrs: {
                                      "data-cy": "remove-attachment",
                                      icon: "remove_circle_outline",
                                      size: "small",
                                      color: "danger"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeAdditionalFile(file.id)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm.withClassification
                                ? _c(
                                    "b-td",
                                    { staticClass: "text-center" },
                                    [
                                      _c("vs-checkbox", {
                                        staticClass: "ml-5 pl-5",
                                        model: {
                                          value: file.interno,
                                          callback: function($$v) {
                                            _vm.$set(file, "interno", $$v)
                                          },
                                          expression: "file.interno"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.withTrueCopy ||
                              _vm.$route.params.from === "edit"
                                ? _c(
                                    "b-td",
                                    { staticClass: "text-center" },
                                    [
                                      _c("b-form-select", {
                                        attrs: { options: _vm.trueCopyOptions },
                                        model: {
                                          value: file.trueCopy,
                                          callback: function($$v) {
                                            _vm.$set(file, "trueCopy", $$v)
                                          },
                                          expression: "file.trueCopy"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }